/**
 * The Quick Bytes tile on the `/mindspace` dashboard.
 *
 * A title, a subtitle, a marquee and a CTA. Everything moving lives in
 * `QuickBytesMarqueePreview`; everything else is `MindspaceDashboardCard`.
 */

import { MindspaceDashboardCard } from '@/components/features/mindspace/cards/MindspaceDashboardCard';
import { QuickBytesMarqueePreview } from '@/components/features/mindspace/quick-bytes/QuickBytesMarqueePreview';

export function QuickBytesCard() {
  return (
    <MindspaceDashboardCard
      title='Quick Bytes'
      subtitle='Bite-sized concept review'
      actionPath='/mindspace/quick-bytes'
      actionLabel='Start Reviewing'
    >
      <div className='flex h-full min-h-[300px] w-full items-center justify-center'>
        <QuickBytesMarqueePreview />
      </div>
    </MindspaceDashboardCard>
  );
}
